import http from '@/utils/http'

export function addBadges(data){
    return http.post('/badges',data)
}
